module.exports = __webpack_public_path__ + "../resources/img/ic_bar.e7990363.svg";